'use strict';

var simpleListGraphModalCtrl = ['$state', '$scope', '$uibModal', function ($state, $scope, $uibModal) {
    var _this = this;
    // console.log('simpleListGraphModalCtrl $scope', $scope)
    try {
        _this.parsedField = JSON.parse(_this.field);
    } catch (error) {
        console.log(error);
    }

    _this.viewList = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'gridGraph-directive/simpleListGraphModal.html',
            controller: ['field', 'data', 'gridConfiguration', function (field, data, gridConfiguration) {
                this.data = data;
                this.field = field;
                this.nodesKeys = {};

                if (this.field.nodes && typeof this.field.nodes === 'object') {
                    Object.values(this.field.nodes).forEach(nodeValue => {
                        if (nodeValue && nodeValue.name) {
                            this.nodesKeys[nodeValue.name] = nodeValue;
                        }
                    });
                }
                // console.log('this.nodesKeys', this.nodesKeys);

                this.numberFormatter = function (value, node) {
                    if (value === null || value === undefined) {
                        return '';
                    }

                    let formattedValue = value;
                    const field = node;

                    if (field && field.templateData) {
                        let numericValue = parseFloat(value);
                        if (isNaN(numericValue)) {
                            return formattedValue;
                        }
                        if (field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number') {
                            formattedValue = numericValue.toFixed(field.templateData.maxDecimalsCount);
                            numericValue = parseFloat(formattedValue);
                        } else {
                            formattedValue = numericValue;
                        }
                        if (field.templateData.thousandSeparator) {
                            formattedValue = new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number' ? field.templateData.maxDecimalsCount : 0,
                                maximumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.maxDecimalsCount === 'number' ? field.templateData.maxDecimalsCount : 20
                            }).format(numericValue);
                        }
                    }
                    return formattedValue;
                };

                this.formulaFormatter = function (value, node) {
                    if (value === undefined) {
                        return '';
                    }

                    let rawValue = value;
                    let formattedValue = rawValue;
                    const field = node;

                    if (field && field.templateData && !field.templateData.isAdvanced) {
                        let numericValue = parseFloat(rawValue);
                        if (isNaN(numericValue)) {
                            return formattedValue;
                        }
                        if (field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number') {
                            formattedValue = numericValue.toFixed(field.templateData.formula.decimals);
                            numericValue = parseFloat(formattedValue);
                        } else {
                            formattedValue = numericValue;
                        }
                        if (field.templateData.thousandSeparator) {
                            formattedValue = new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number' ? field.templateData.formula.decimals : 0,
                                maximumFractionDigits: field.templateData.forceDecimals && typeof field.templateData.formula?.decimals === 'number' ? field.templateData.formula.decimals : 20
                            }).format(numericValue);
                        }
                    }
                    return formattedValue?.toString();
                };

                this.dataValues = data[field.name]?.map((item) => {
                    const keyValuePairs = item?.split(";").filter(pair => pair);
                    const obj = {};

                    keyValuePairs.forEach(pair => {
                        const [key, value] = pair.split(":");
                        let formattedValue = value;

                        let node = this.nodesKeys[key.trim()];

                        if (node && node.type == 'number') {
                            formattedValue = this.numberFormatter(value, node);
                        } else if (node && node.type == 'formula') {
                            formattedValue = this.formulaFormatter(value, node);
                        } else {
                            formattedValue = value.split('|')[1] || value;
                        }
                        obj[key.trim()] = (formattedValue && formattedValue !== 'null') ? formattedValue : "";
                    });
                    return obj;
                });


                this.titles = Object.keys(this.dataValues[0] || {}).map(key => this.nodesKeys[key.trim()]);
                // console.log('this.dataValues', this.dataValues);
                // console.log('this.titles', this.titles);
            }],
            controllerAs: 'modal',
            size: 'xlg',
            resolve: {
                field: function () {
                    return _this.parsedField;
                },
                data: function () {
                    return _this.data;
                }
                
            },
            windowClass: 'dialog',
            bindToController: true
        });

        modalInstance.result.then(function (selectedItem) {
            _this.selected = selectedItem;
        }, function () {

        });
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '@',
            data: '='
        },
        controller: simpleListGraphModalCtrl,
        controllerAs: 'modal',
        bindToController: true,
        // template: '<a ng-if="modal.data[modal.parsedField.name].length>0" ng-click="modal.viewList(); $event.stopPropagation()">{{modal.data[modal.parsedField.name].length}} registros <i class="glyphicon glyphicon-list-alt"></i><i class="glyphicon glyphicon-book"></i><i class="glyphicon glyphicon-file"></i><i class="glyphicon glyphicon-education"></i><i class="glyphicon glyphicon-info-sign"></i></a>'
        template: '<a ng-if="modal.data[modal.parsedField.name].length>0" ng-click="modal.viewList(); $event.stopPropagation()">{{modal.data[modal.parsedField.name].length}} <i class="glyphicon glyphicon-file"></i></a>'
    };
};
